import React, { useEffect } from "react";
import { useLang } from "@/lib/i18n";
import Nav from "@/components/berlin/Nav";
import Footer from "@/components/berlin/Footer";
import Realisiert from "@/components/berlin/Realisiert";
import Vorfuehrung from "@/components/berlin/Vorfuehrung";
import Transformation from "@/components/berlin/Transformation";
import Gallery from "@/components/berlin/Gallery";
import Today from "@/components/berlin/Today";
import Collection from "@/components/berlin/Collection";
import Impact from "@/components/berlin/Impact";
import Technology from "@/components/berlin/Technology";
import Financing from "@/components/berlin/Financing";
import PresseMedien from "@/components/berlin/PresseMedien";

// Unterseiten mit den bisherigen Startseiten-Abschnitten (Relaunch 04.11.2026)
export const ARCHIV_SEO = {
  projekte: { de: { p: "/projekte", title: "Projekte: Kantstraße und Wustermark | Berlin-Cube", description: "Alle Fotos und Videos der realisierten Berlin-Cube-Anlage in der Berliner Kantstraße und der Vorführung in Wustermark — Vorher/Nachher und Jahreszeiten." }, en: { p: "/en/projects", title: "Projects: Kantstraße and Wustermark | Berlin-Cube", description: "All photos and videos of the built Berlin-Cube installation on Berlin's Kantstraße and the demonstration in Wustermark." } },
  technologie: { de: { p: "/technologie", title: "Technologie: Module, Collection, Impact | Berlin-Cube", description: "Technik und Varianten des Berlin-Cube: geprüfter Cube, Seilverbindung, Collection, Impact und Finanzierung." }, en: { p: "/en/technology", title: "Technology: modules, collection, impact | Berlin-Cube", description: "Technology and variants of the Berlin-Cube: tested Cube, cable connection, collection, impact and financing." } },
  presse: { de: { p: "/presse", title: "Presse und Medien | Berlin-Cube", description: "Alle Artikel und Beiträge über Berlin-Cube: rbb24, Tagesspiegel, Berliner Morgenpost, Entwicklungsstadt Berlin." }, en: { p: "/en/press", title: "Press and media | Berlin-Cube", description: "All articles and reports about Berlin-Cube." } },
};

const Shell = ({ k, children }) => {
  const { lang } = useLang();
  useEffect(() => {
    const s = ARCHIV_SEO[k][lang];
    document.title = s.title;
    document.querySelector('meta[name="description"]')?.setAttribute("content", s.description);
    window.scrollTo(0, 0);
  }, [k, lang]);
  return (
    <div className="bg-[#0F1114] text-white min-h-screen" data-testid={`page-${k}`}>
      <Nav />
      <main className="pt-20">{children}</main>
      <Footer />
    </div>
  );
};

export const Projekte = () => <Shell k="projekte"><Realisiert /><Vorfuehrung /><Transformation /><Gallery /></Shell>;
export const Technologie = () => <Shell k="technologie"><Today /><Collection /><Impact /><Technology /><Financing /></Shell>;
export const Presse = () => <Shell k="presse"><PresseMedien /></Shell>;
